import type { DOMProps } from "@simplybusiness/mobius";
import { Flex } from "@simplybusiness/mobius";
import classNames from "classnames/dedupe";
import type { RefAttributes } from "react";

export type QuestionnaireActionsRootElement = HTMLDivElement;

export interface QuestionnaireActionsRootProps
  extends DOMProps, RefAttributes<QuestionnaireActionsRootElement> {
  /** Custom class name for setting specific CSS */
  className?: string;
  /** Child action components */
  children?: React.ReactNode;
}

/**
 * Root wrapper component for questionnaire actions.
 * Provides layout container (Flex) for action components.
 * Use as compound component: <QuestionnaireActions><QuestionnaireActions.Back />...</QuestionnaireActions>
 */
export const QuestionnaireActionsRoot = ({
  ref,
  ...props
}: QuestionnaireActionsRootProps) => {
  const { className, children, ...rest } = props;

  const classes = classNames("mobius", "mobius-actions", className);

  return (
    <Flex
      ref={ref}
      className={classes}
      justifyContent="space-between"
      alignItems="center"
      {...rest}
    >
      {children}
    </Flex>
  );
};

QuestionnaireActionsRoot.displayName = "QuestionnaireActionsRoot";
